import React, { PureComponent } from "react";
import Dropzone from "react-dropzone";
import classNames from "classnames";
import FormErrorMessage from "../form-error-message/form-error-message";
import "./image-upload.scss";

class ImageUploadV2 extends PureComponent {
  constructor() {
    super();
    this.state = {
      currentIndexSelected: null,
    };
  }
  attemptImageProcess = (acceptedFiles, rejectedFiles) => {
    const file = acceptedFiles[0];
    if (file.size > 2000000) {
      this.props.updateImage({
        imageErrorMessage:
          "Please choose an image that is less than 2mb in size",
      });
      return;
    }

    if (rejectedFiles.length > 0) {
      this.props.updateImage({
        imageErrorMessage:
          "Image must be one of the following: jpeg, jpg, png or gif",
      });
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      const image = new Image();
      image.onload = () => {
        const { height, width } = image;
        if (height < 200 || width < 200) {
          return this.props.updateImage({
            imageErrorMessage: "Image must be at least 200x200 pixels in size",
          });
        }
        const ratio = height / width >= 1 ? "portrait" : "landscape";

        const shrinkRatioX = 250 / width;
        const shrinkRatioY = 250 / height;

        this.props.updateImage({
          profilePic: reader.result,
          profilePicLastModified: file.lastModified,
          imgSizeX: ratio === "portrait" ? 250 : shrinkRatioY * width,
          imgSizeY: ratio === "landscape" ? 250 : shrinkRatioX * height,
          ratio,
          controlledPositionX: 0,
          controlledPositionY: 0,
        });
      };

      image.src = reader.result;
    };

    reader.readAsDataURL(file);
  };

  onDrop = (acceptedFiles, rejectedFiles) => {
    this.props.updateImage({
      imageErrorMessage: undefined,
    });
    this.attemptImageProcess(acceptedFiles, rejectedFiles);
  };

  settingAvatar = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], "ddd", { type: blob.type });
    const reader = new FileReader();

    reader.onloadend = () => {
      const image = new Image();
      image.onload = () => {
        const { height, width } = image;
        if (height < 200 || width < 200) {
          return this.props.updateImage({
            imageErrorMessage: "Image must be at least 200x200 pixels in size",
          });
        }
        const ratio = height / width >= 1 ? "portrait" : "landscape";

        const shrinkRatioX = 250 / width;
        const shrinkRatioY = 250 / height;

        this.props.updateImage({
          profilePic: reader.result,
          profilePicLastModified: file.lastModified,
          imgSizeX: ratio === "portrait" ? 250 : shrinkRatioY * width,
          imgSizeY: ratio === "landscape" ? 250 : shrinkRatioX * height,
          ratio,
          controlledPositionX: 0,
          controlledPositionY: 0,
        });
      };

      image.src = reader.result;
    };

    reader.readAsDataURL(file);
  };

  render() {
    const {
      imageErrorMessage,
      profilePic,
      imgSizeX,
      imgSizeY,
      ratio,
      isEditable = true,
    } = this.props;
    return (
      <>
        <div className="image-upload">
          <div className="image-preview">
            {profilePic && (
              <div className="image-upload__box">
                <div className="image-upload__img-cont">
                  <div
                    className="image-upload__img-handle "
                    // style={{ height: `${imgSizeY}px`, width: `${imgSizeX}px` }}
                    style={{ height: "250px" }}
                  >
                    <img
                      className={`image-upload__img ${
                        ratio === "portrait"
                          ? "image-upload__img--portrait"
                          : "image-upload__img--landscape"
                      } `}
                      src={profilePic}
                      alt="Profile Picture"
                    />
                    <div className="image-upload__img-cover" />
                  </div>
                </div>
              </div>
            )}
            <div className="image-upload__inner">
              <FormErrorMessage
                isValid={imageErrorMessage === undefined}
                validationErrorMsg={imageErrorMessage}
              />

              {isEditable && (
                <Dropzone
                  onDrop={this.onDrop}
                  multiple={false}
                  accept="image/jpeg, image/png, image/jpg"
                >
                  {({ getRootProps, getInputProps, isDragActive }) => {
                    return (
                      <div
                        {...getRootProps()}
                        className={classNames("dropzone", {
                          "dropzone--isActive": isDragActive,
                        })}
                      >
                        <input {...getInputProps()} />
                        <div className="image-upload__drop-area">
                          {isDragActive ? (
                            <p>Drop files here...</p>
                          ) : (
                            <p>
                              {profilePic
                                ? "Click here to change image"
                                : "Drag your image onto this box, or click to select an image to upload."}
                            </p>
                          )}
                        </div>
                      </div>
                    );
                  }}
                </Dropzone>
              )}
            </div>
          </div>
          {/* avatar section */}
          <div className="image-section">
            <p>
              We recommend using a real profile picture, but feel free to use a
              default avatar temporarily:
            </p>
            <div className="image-selected-section">
              {Array.from({ length: 14 }, (_, i) => i + 1).map((i) => (
                <img
                  width={80}
                  height={80}
                  className={
                    this.state.currentIndexSelected === i ? "image-seleted" : ""
                  }
                  src={`static/avatar/avatar_img_${i}.png`}
                  onClick={() => {
                    this.settingAvatar(`static/avatar/avatar_img_${i}.png`);
                    this.setState({ currentIndexSelected: i });
                    this.props.updateImage({
                      imageErrorMessage: undefined,
                    });
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ImageUploadV2;
